// extracted by mini-css-extract-plugin
export var cancelCustomClass = "NSDCRemoveoPopUpModal-module--cancelCustomClass--d0c8f";
export var cancelCustomTextClass = "NSDCRemoveoPopUpModal-module--cancelCustomTextClass--83dee";
export var handleButtons = "NSDCRemoveoPopUpModal-module--handleButtons--95f54";
export var lmsScrollbar = "NSDCRemoveoPopUpModal-module--lms-scrollbar--5613f";
export var modalContentContainer = "NSDCRemoveoPopUpModal-module--modalContentContainer--b3300";
export var notes = "NSDCRemoveoPopUpModal-module--notes--478f1";
export var nsdcDetails = "NSDCRemoveoPopUpModal-module--nsdcDetails--792bb";
export var removeCustomClass = "NSDCRemoveoPopUpModal-module--removeCustomClass--81e62";
export var removeCustomTextClass = "NSDCRemoveoPopUpModal-module--removeCustomTextClass--14b79";